import React from 'react';
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
//import {Bar} from 'react-chartjs-2';
import { IsEmptyValue } from '../../helpers';
//import {Chart} from 'chart.js/auto'
//import { Button } from 'react-bootstrap';


  


export default class App extends React.Component {
  render() {
    ChartJS.register(
        LinearScale,
        CategoryScale,
        BarElement,
        PointElement,
        LineElement,
        Legend,
        Tooltip,
        LineController,
        BarController
    );

    const state = {
        labels: this.props.datos.labels,
        datasets: [
          {
            type: 'line',
            label: 'P. Totales',
            backgroundColor: 'rgba(91,192,222)',
            borderColor: 'black',
            borderWidth: 1,
            data: this.props.datos.totales
          },
          {
            type: 'line',
            label: 'P. Recibidos',
            backgroundColor: 'rgba(240,173,78)',
            borderColor: 'black',
            borderWidth: 1,
            data: this.props.datos.recibidos
          },
          {
            type: 'line',
            label: 'P. Delivery',
            backgroundColor: 'rgba(51, 153, 255)',
            borderColor: 'black',
            borderWidth: 1,
            data: this.props.datos.delivery
          },
          {
            type: 'line',
            label: 'P. En ruta',
            backgroundColor: 'rgba(255, 102, 0)',
            borderColor: 'black',
            borderWidth: 1,
            data: this.props.datos.en_ruta
          },
          {
            type: 'line',
            label: 'P. En Preparación',
            backgroundColor: 'rgba(187,33,36)',
            borderColor: 'black',
            borderWidth: 1,
            data: this.props.datos.en_preparacion
          },
          {
            type: 'line',
            label: 'P. Entregados',
            backgroundColor: 'rgba(34,187,51)',
            borderColor: 'black',
            borderWidth: 1,
            data: this.props.datos.entregados
          }
        ]
      }

    //const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];
    const labels = this.props.datos.labels;
    const data = {
        labels,
        datasets: state.datasets
        // datasets: [
        //     {
        //     type: 'line',
        //     label: 'Dataset 1',
        //     borderColor: 'rgb(255, 99, 132)',
        //     borderWidth: 2,
        //     fill: false,
        //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        //     },
        //     {
        //     type: 'bar',
        //     label: 'Dataset 3',
        //     backgroundColor: 'rgb(53, 162, 235)',
        //     fill: false,
        //     //data:{state}
        //     data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
        //     },
        // ],
    };

    return (
      <div style ={{width : '100%'}}>
        <Chart 
          type='bar' 
          data={data}
          options={{ 
            interaction: {
              intersect: false,
              mode: 'index',
            },
          }}
        />;
      </div>
    );
  }
  
}
